<template>
  <b-modal id="identity" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">ID Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.id_types" v-model="input_data.id_type" :reduce="id_type=>id_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Register Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input  v-model="input_data.registered_name" placeholder="Enter your registered name"></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input  v-model="input_data.registered_number" placeholder="Enter your registered number"></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-input  v-model="input_data.description" placeholder="Enter description"></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      :reduce="data=>data.value"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.defaults"
                      :reduce="data=>data.value"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status change by employee</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.status_change_by"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Status change
                  </b-form-checkbox>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Attachment</label>
                <div class="col-md-8 mb-3">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>

import {BButton, BForm, BFormRadioGroup, BFormInput, BModal, BFormCheckbox} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "IdentityInput",
  components:{
    BForm,
    BFormRadioGroup,
    BFormInput,
    BFormCheckbox,
    flatPickr,
    BButton,
    BModal,
    vSelect
  },
  props:{
    data:{
      type:Object,
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        id_type:"",
        registered_name:"",
        registered_number:"",
        status_change_by:"",
        expiration_date:"",
        status:"",
        description:""
      },
      options:{
        id_types:[],
        status:[{text:"Active", value:"active"}, {text: "Non Active", value:"non_active"}],
        defaults:[{text:"Yes", value:"yes"}, {text: "no", value:"no"}]
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null ){
          this.title = "Update"
          this.input_data.id_type = this.data.type_id
          this.input_data.registered_name = this.data.registered_name
          this.input_data.registered_number = this.data.registered_number
          this.input_data.expiration_date = this.data.valid_from
          this.input_data.status = (this.data.status == 1) ? 'active': 'non_active'
          this.input_data.description = this.data.desc
          this.input_data.default = this.data.is_default==1?'yes':'no'
        }
      }, 100)
    },
    onSubmit(){
      let payload = {
        emp_id : this.$store.getters.empId,
        identype_id:this.input_data.id_type,
        registered_number:this.input_data.registered_number,
        registered_name:this.input_data.registered_name,
        valid_date:this.input_data.expiration_date,
        status:(this.input_data.status === "active"?1:0),
        desc:this.input_data.description,
        user_id:this.$store.getters.userId
      }

      if (this.data !== null ){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.identity.update).then(res =>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.identity.add).then(res =>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }

    },
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.items = []
      this.$parent.data= null
      this.input_data = {
        id_type:"",
        registered_name:"",
        registered_number:"",
        status_change_by:"",
        expiration_date:"",
        status:"",
        description:""
      }
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    getIdentityType(){
      AxiosCall.Get({}, urlApi.identity.type).then(res=>{
        if (res.success){
          this.options.id_types = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(JSON.stringify(e))
        this.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    this.getIdentityType()
  }
}
</script>